import Login from './pages/auth/Login.svelte';
import Dashboard from './pages/dashboard/Dashboard.svelte';
import Inquiry from './pages/Inquiry/Inquiry.svelte';
import NotFound from './pages/NotFound.svelte'; // 혹은 바로 Redirect
import Notice from './pages/notice/Notice.svelte';
import PlanManagement from './pages/plan/PlanManagement.svelte';
import ProblemType from './pages/problem-type/ProblemType.svelte';
import ServiceHistory from './pages/servicehistory/ServiceHistory.svelte';
import UserManagement from './pages/user/UserManagement.svelte';
const routes = {
    '/': Login ,     
    '/dashboard': Dashboard,
    '/users': UserManagement,
    '/inquiry': Inquiry,
    '/notice': Notice,
    '/svc-history': ServiceHistory,
    '/planmng':PlanManagement,
    '/problem-type': ProblemType,
    '*': NotFound, // 👈 없는 경로 fallback 처리
};

export default routes;